import React, { useState, InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './PasswordInput.css';

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  error?: string;
  label?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  error,
  label,
  className = '',
  id,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = () => {
    setShowPassword(!showPassword);
  };

  const inputId = id || `password-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="password-input-wrapper">
      {label && (
        <label htmlFor={inputId} className="password-input-label">
          {label}
        </label>
      )}
      <div className="password-input-container">
        <input
          {...props}
          id={inputId}
          type={showPassword ? 'text' : 'password'}
          className={`password-input-field ${className} ${error ? 'password-input-error' : ''}`}
        />
        <button
          type="button"
          className="password-toggle-btn"
          onClick={toggleVisibility}
          tabIndex={-1}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? (
            <EyeOff size={20} />
          ) : (
            <Eye size={20} />
          )}
        </button>
      </div>
      {error && <span className="password-input-error-text">{error}</span>}
    </div>
  );
};

export default PasswordInput;
